import React, { Component } from "react";

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        style={{
          margin: "auto",
          maxWidth: "600px",
          padding: "20px",
        }}
      >
        <h1>About Us</h1>
        <div>
          Makers Eric (left) & Kyle (right)<br></br>
          <br></br>
          Hello there 👋! <br></br>
          <br></br> Kyle is a former engineer at Cruise and is currently in
          Harvard Business School. Eric built a profitable, NLP-based SaaS
          company called Y Translator. <br></br>
          <br></br>
          We met in an interesting 74-person coliving place called{" "}
          <a target="_blank" href="https://www.tribecoliving.com/">
            Tribe
          </a>{" "}
          in San Francisco and recently relocated to Mexico City! (Anyone in the
          area? Let’s connect!)
          <br></br>
          <br></br>
          We love reading online since it’s one of the most effective ways to
          discover new perspectives. However, reading is kinda hard and
          time-consuming 🤷‍♂️ which lead us to constantly having a huge backlog of
          things to read.
          <br></br>
          <br></br>
          At some point, we turned Paul Graham’s essays into audio podcasts for
          fun. We loved listening to them, as did our friends. So we decided to
          create a tool that allows you to do just that -- listen to any web
          article.
          <br></br>
          <br></br>
          We use Audiblogs to “read” while we exercise, cook, run errands, etc.
          We now have 1-2 hours of extra time per day that we can use to read
          other things!
          <br></br>
          <br></br>
          If you love to read but don’t have enough time, you’ll love Audiblogs!
          <br></br>
          <br></br>
          <b>
            <i>Try it and let us know what you think!</i>
          </b>
          <br></br>
          <br></br>
          Eric{" "}
          <a target="_blank" href="https://www.linkedin.com/in/automationist/">
            LinkedIn
          </a>{" "}
          <br></br>Kyle{" "}
          <a target="_blank" href="https://www.linkedin.com/in/kylejohnmorris/">
            LinkedIn
          </a>
        </div>
        <div>
          <h1>Our Motivation</h1>
          <div>
            <h2>Why do we read?</h2>
            Humans have an innate desires to learn. If we didn't, we wouldn't
            have all developed such complex languages. Instead, we'd still be
            communicating with the same simplicity as other animals, using basic
            sounds to express things like "<i>eat</i>," "<i>sleep</i>," "
            <i>fight</i>," etc.
            <br></br>
            <br></br>Languages evolved to enable us to express ideas and learn
            from each other. And about 5,000 years ago, humanity figured out a
            way to communicate and spread knowledge at scale: <i>BOOKS</i>.
            <br></br>
            <br></br>
            This revolutionary invention allowed us to learn from people on the
            other side of the world, going beyond the limitations of
            word-of-mouth communication.
            <br></br>
            <br></br>
            Over thousands of years, reading became the ultimate source of
            wisdom. If you're smart, you read. If you read, you're smart.
            Reading has become the necessary and sufficient condition that makes
            a person wise in our society.
            <br></br>
            <br></br>
            <h2>Why not to read?</h2>
            We think that reading isn't the most natural way to learn. We've
            been taught to think that reading is the best way, but only because
            it's cheap and has been the status quo for thousands of years.
            <br></br>
            <br></br>
            Imagine this: Would you rather read a book for hours or have an
            opportunity to discuss with the author 1-on-1 for a couple of hours?
            <br></br>
            <br></br>
            The author would condense the knowledge and adapt the language in a
            way that <i>you</i> can understand. You can go back and forth asking
            questions, clarifications, and more.
            <br></br>
            <br></br>
            Discussion is superior to reading when it comes to learning.
            Unfortunately, this is extremely expensive. Popular authors simply
            do not have enough time to chat with everyone.
            <br></br>
            <br></br>
            <h2>What's next?</h2>
            We believe we can replicate the experience of learning directly from
            the authors through verbal discussion, thanks to recent
            breakthroughs in Artificial Intelligence (AI), particularly in
            Speech Recognition, Natural Language Processing, and Speech
            Synthesis.
            <br></br>
            <br></br>
            This actually isn't as far-fetched as it may sound. We have a small
            demo coming up that may give you a glimpse of what might be possible
            in the future (Hint: GPT-3). So, stay tuned!
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
